// Checkout catalog vs build-on-order UI mode
import { getBuildOrderDraft } from '../../app/build-draft.js';
import { getCheckoutMode, isBuildCheckoutMode, setCheckoutMode } from '../../app/checkout-mode.js';
import { getIsUpgradeMode } from '../../app/app-state.js';
import {
  refreshBuildCheckoutOrderSummary,
  refreshCheckoutOrderSummary,
  refreshCheckoutPaymentSummary
} from './summary.js';

export { setCheckoutMode, getCheckoutMode, isBuildCheckoutMode };

function getBuildBackView(): string {
  const draft = getBuildOrderDraft();
  if (!draft) return 'view-build';
  if (draft.requestType === 'components') return 'view-build-yes';
  if (getIsUpgradeMode()) return 'view-build-no';
  return 'view-build-no';
}

export function applyCheckoutModeUi(): void {
  const view = document.getElementById('view-checkout');
  const build = isBuildCheckoutMode();
  if (view) view.classList.toggle('checkout-view--build', build);

  const backBtn = document.getElementById('checkout-back-btn');
  if (backBtn) {
    backBtn.setAttribute('data-back-to', build ? getBuildBackView() : 'view-presets');
  }

  const titleEl = document.getElementById('checkout-page-title');
  if (titleEl) titleEl.textContent = build ? 'Оформление заявки' : 'Оформление заказа';

  const submitBtn = document.getElementById('checkout-submit-btn');
  if (submitBtn) submitBtn.textContent = build ? 'Отправить заявку' : 'Перейти к оплате';

  const orderTitle = document.getElementById('checkout-order-section-title');
  if (orderTitle) orderTitle.textContent = build ? 'Ваша заявка' : 'Заказ';

  const bannerTitle = document.getElementById('checkout-build-banner-title');
  const draft = getBuildOrderDraft();
  if (bannerTitle && draft?.label) bannerTitle.textContent = draft.label;

  try {
    if (build) {
      refreshBuildCheckoutOrderSummary();
    } else {
      refreshCheckoutOrderSummary();
      refreshCheckoutPaymentSummary();
    }
  } catch {
    /* ignore */
  }
}

export function enterBuildCheckout(): void {
  setCheckoutMode('build');
  applyCheckoutModeUi();
}

export function enterCatalogCheckout(): void {
  setCheckoutMode('catalog');
  applyCheckoutModeUi();
}
